import { AreaGate } from './../../../../components/visit-overview/dialog/register-entrance/model/areaGate';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { SelectFieldOption, TranslationService } from '@sdbn/common';

@Component({
  selector: 'app-gate',
  templateUrl: './gate.component.html',
  styleUrls: ['./gate.component.scss']
})
export class GateComponent implements OnInit {

  options = new Array<SelectFieldOption>();

  formGroup = new FormGroup({
    gate: new FormControl(null, [])
  });

  @Input('gates') set setGates(gates: Array<AreaGate>) {
    for (let gate of gates) {
      this.options.push(new SelectFieldOption({
        label: gate.name,
        value: gate.id
      }));
    }

  }

  @Output() selectionChanged = new EventEmitter<number>();

  constructor(public translationService: TranslationService) { }

  ngOnInit(): void {

    this.formGroup.valueChanges.subscribe(value => {
      this.selectionChanged.next(value.gate);
    });

    this.formGroup.patchValue({ gate: this.options[0].value });

  }

}
